import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, computed, effect, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { AboutHotel, HotelSummaryModel } from '@core/models/domains/hotel';
import { AbouthotelModalComponent } from '../../components/abouthotel-modal/abouthotel-modal.component';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { ModalService } from '@shared/services/modal.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-about-hotel',
 standalone: true,
 imports: [CommonModule, MatButtonModule],
 templateUrl: './about-hotel.component.html',
 styleUrls: ['./about-hotel.component.scss'],
})
export class AboutHotelComponent implements OnInit {
 dialog = inject(MatDialog);

 destroyRef = inject(DestroyRef);

 @Input() set dataSource(value: any) {
  this.hotelInfoSummery = value;
 }

 ngOnInit(): void {
  // this.hotelInfoSummery = this.hotelInfoUiService.hotelInfo();
 }

 constructor() {}

 modalService = inject(ModalService);
 aboutHotelsectionTemplate!: string;
 searchBoxService = inject(SearchBoxService);

 accommodation = computed(() => this.searchBoxService.accommodation());
 hotelInfoSummery!: HotelSummaryModel;

 showModal() {
  const dialogRef = this.dialog.open(AbouthotelModalComponent, {
   panelClass: [
    'abouthotel-modal',
    'w-screen',
    'lg:w-[80%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[90%]',
   ],
   data: {
    //  dataSource: this.dataSource,
    aboutHotelData: this.hotelInfoSummery,
    hid: 214,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    this.modalService.isAnyModalOpen.set(false);
   });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }
}
